import { CheckCircleOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import type { JSX } from 'react'

export type CloudfrontStatus =
  | 'pending'
  | 'dns_validation_required'
  | 'certificate_provisioning'
  | 'deploying'
  | 'active'
  | 'failed'

export const CLOUDFRONT_STATUS_LABEL: Record<CloudfrontStatus, string> = {
  pending: 'Pending',
  dns_validation_required: 'DNS Validation Required',
  certificate_provisioning: 'Certificate Provisioning',
  deploying: 'Deploying',
  active: 'Active',
  failed: 'Failed',
}

type CloudfrontStatusTagProps = {
  status: CloudfrontStatus
}

export function CloudfrontStatusTag({ status }: CloudfrontStatusTagProps): JSX.Element {
  if (status === 'active') {
    return (
      <>
        <Tag color="green" icon={<CheckCircleOutlined />}>
          SSL Active
        </Tag>
        <Tag color="green" icon={<CheckCircleOutlined />}>
          Verified
        </Tag>
      </>
    )
  }

  if (status === 'failed') {
    return <Tag color="red">Failed</Tag>
  }

  if (status === 'deploying') {
    return <Tag color="blue">Deploying</Tag>
  }

  return (
    <>
      {status === 'certificate_provisioning' && <Tag color="orange">Provisioning</Tag>}
      <Tag color="orange">Pending</Tag>
    </>
  )
}
